import React from 'react';
import { Assessment } from '@exerai/vision-engine-web';
import { Typography } from '@mui/material';
import { Nullish } from '@/common/types';
import { OutcomeFactorTableContainer } from '@/components/Scan/Outcomes/OutcomeFactorTable/OutcomeFactorTableContainer';
import { OutcomeSliderContainer } from '@/components/Scan/Outcomes/OutcomeSlider/OutcomeSliderContainer';
import { AssessmentOutcome } from '@/components/Scan/Outcomes/types/types';
import { outcomeUsesSidedResults } from '@/components/Scan/Outcomes/utils';
import { OutcomesContentWrapper, TypographyWrapper } from './styles';

interface AssessmentOutcomePreviewProps {
    outcome: AssessmentOutcome;
    assessment?: Assessment;
}

export const AssessmentOutcomePreview = (props: AssessmentOutcomePreviewProps) => {
    const { outcome, assessment } = props;
    const resultDefinitionIds: { display: string; id: string }[] = [];
    const addResultDefinitionId = (display: string, id: Nullish<string>) => {
        if (id) {
            resultDefinitionIds.push({ display, id });
        }
    };
    if (outcomeUsesSidedResults(outcome?.type, assessment)) {
        addResultDefinitionId('Left Result Definition Id', outcome?.leftResultDefinitionId);
        addResultDefinitionId('Right Result Definition Id', outcome?.rightResultDefinitionId);
    } else {
        addResultDefinitionId('Result Definition Id', outcome?.resultDefinitionId);
    }
    if (outcome) {
        return (
            <OutcomesContentWrapper>
                {outcome?.title && (
                    <TypographyWrapper>
                        <Typography marginRight={1} fontWeight={'bold'}>
                            Title:
                        </Typography>
                        <Typography fontStyle={'italic'}>{outcome.title}</Typography>
                    </TypographyWrapper>
                )}
                {outcome?.description && (
                    <TypographyWrapper>
                        <Typography marginRight={1} fontWeight={'bold'}>
                            Description:
                        </Typography>
                        <Typography fontStyle={'italic'}>{outcome.description}</Typography>
                    </TypographyWrapper>
                )}
                {resultDefinitionIds.map((rd) => (
                    <TypographyWrapper key={rd.id}>
                        <Typography marginRight={1} fontWeight={'bold'}>
                            {rd.display}
                        </Typography>
                        <Typography>{rd.id}</Typography>
                    </TypographyWrapper>
                ))}

                {outcome?.demographicsRequired ? (
                    <OutcomeFactorTableContainer result={null} factors={outcome.factors} />
                ) : (
                    <OutcomeSliderContainer type={outcome?.type} factors={outcome?.factors} />
                )}
                <TypographyWrapper>
                    <Typography marginRight={1} fontWeight={'bold'}>
                        Source:
                    </Typography>
                    <Typography fontStyle={'italic'}>{outcome?.source}</Typography>
                </TypographyWrapper>
            </OutcomesContentWrapper>
        );
    }
    return null;
};
